export type TokenCallback = (scopes: string[]) => Promise<string>;
export const scopes = [
  "499b84ac-1321-427f-aa17-267ca6975798/user_impersonation", // Azure devops
];
export const azureOrganizationUrl = "https://dev.azure.com/upslidepyramid";
